
import { ref, defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import User from "@/models/user";
import { i18n } from "../../i18n";
import { showMessage } from "@/services/MessageService";
import { useRoute } from "vue-router";

export default defineComponent({
  setup() {
    const route = useRoute();
    const passwordform: any = ref(null);
    return {
      passwordform,
      route,
    };
  },
  data() {
    return {
      form: User.getPasswordRecoveryForm(),
    };
  },
  computed: {
    ...mapGetters("user", ["eventData"]),
  },
  methods: {
    ...mapActions("user", ["resetPasswordAction"]),
    resetPassword(email) {
      this.passwordform.validate((valid) => {
        if (valid) {
          this.resetPasswordAction({
            email,
            eventID: this.route.params.eventID,
          });
          showMessage({
            title: i18n.global.t("recoveryPassword.recoverySuccess.title"),
            message: i18n.global.t("recoveryPassword.recoverySuccess.message"),
            type: "success",
          });
          this.form.email.value = "";
          this.$router.push("/" + this.route.params.eventID);
        } else {
          return false;
        }
      });
    },
  },
});
